if (!customElements.get('announcement-marquee')) {
  class AnnouncementMarquee extends HTMLElement {
    connectedCallback() {
      this._io = new IntersectionObserver(
        (entries, obs) => {
          if (!entries[0].isIntersecting) return;
          obs.disconnect();
          this.init();
        },
        { rootMargin: '200px' }
      );
      this._io.observe(this);
    }

    init() {
      const speedSeconds = parseInt(this.dataset.speed, 10) || 40;
      // Variable CSS scoped a esta instancia: nunca toca otras announcement-marquee en la página.
      this.style.setProperty('--marquee-duration', `${speedSeconds}s`);

      // El shine corre más rápido que el scroll del marquee, proporcional a su duración.
      const shineSeconds = Math.max(1.8, speedSeconds / 16);
      this.style.setProperty('--shine-duration', `${shineSeconds}s`);
    }

    disconnectedCallback() {
      this._io?.disconnect();
    }
  }

  customElements.define('announcement-marquee', AnnouncementMarquee);
}